import React from 'react';
import { PublicNavbar } from 'src/components/organisms/Navbar';
import * as Types from 'src/types';
import CustomHeader from '../../public/CustomHeader';
import {
  ChildrenWrapper,
  ContentContainer,
  PublicRoutingBody,
  PublicRoutingContainer,
} from './PublicLoggedInContainerWithNavbar.styles';

interface Props extends React.ComponentProps<typeof CustomHeader> {
  selectedTabIndex: number;
  children?: React.ReactNode;
  hideMenusWhenSmall: boolean;
  greyBackground?: boolean;
  shadowBackground?: boolean;
  subHeader?: string;
}

export const PublicLoggedInContainerWithNavbar = (props: Props) => {
  return (
    <PublicRoutingContainer>
      <PublicNavbar
        organisation={props.organisation || ''}
        currentUser={props.currentUser || undefined}
      />
      <PublicRoutingBody
        variant={Types.NavbarVariantEnum.PUBLIC}
        data-testid="opr-user-portal"
      >
        <ContentContainer variant={Types.NavbarVariantEnum.PUBLIC}>
          <CustomHeader
            organisation={props.organisation}
            currentUser={props.currentUser}
            hideMenusWhenSmall={props.hideMenusWhenSmall}
            hideID={props.hideID}
            subHeader={props.subHeader}
          />
          <ChildrenWrapper
            vaultIDShowing={!props.hideID}
            isMessages={props.selectedTabIndex === 1}
            greyBackground={props.greyBackground}
            shadowBackground={props.shadowBackground}
            variant={Types.NavbarVariantEnum.PUBLIC}
            data-testid="opr-user-reports"
          >
            {props.children}
          </ChildrenWrapper>
        </ContentContainer>
      </PublicRoutingBody>
    </PublicRoutingContainer>
  );
};
